// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"637":"b640ec66","787":"d39322fa"}[chunkId] + ".chunk.js";
};